const { REACT_APP_ENVIRONMENT } = process.env;

/** Centralized log handler,
 * Please use this instead of console log
 */
function logHandling(error) {
  // error handle
  //console.log('Log: ', error);
  if (REACT_APP_ENVIRONMENT === 'development') {
    //console.log(error);
  }
}

export default logHandling;